/**
 * @desc 导入员工信息管理模板下载
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/download/staffExcelTemp`, {
      method: "GET",

      ...options,
    }),
  );
}
